import PropTypes from 'prop-types';

const accessibilityShape = PropTypes.shape({
    maxWheelchairSeats: PropTypes.number.isRequired,
});

const departArriveShape = PropTypes.shape({
    cityName: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    dateTime: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    nearby: PropTypes.bool.isRequired,
    region: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    timezoneOffset: PropTypes.number.isRequired,
    utcTime: PropTypes.number.isRequired,
});

const promotionShape = PropTypes.shape({
    discount: PropTypes.shape({
        rate: PropTypes.object.isRequired,
        type: PropTypes.string.isRequired,
    }).isRequired,
    generic: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
});

// this is the shape of our old, stationmaster's-table -esque, trip details
const tripDetailsShape = PropTypes.shape({
    arrives: PropTypes.string,
    carrier: PropTypes.string,
    departs: PropTypes.string,
    layover: PropTypes.string,
    vehicle_type: PropTypes.string,
});
// TODO: we need a shape for the hot new trip-itinerary data
// const tripItineraryShape = PropTypes.shape({ ... })

const tripSchema = {
    accessibility: accessibilityShape.isRequired,
    carrierCode: PropTypes.string.isRequired,
    features: PropTypes.arrayOf(PropTypes.string).isRequired,
    isRouted: PropTypes.bool.isRequired,
    localizedArriveDateTime: PropTypes.string.isRequired,
    localizedDepartDateTime: PropTypes.string.isRequired,
    promotions: PropTypes.arrayOf(promotionShape).isRequired,
    transfers: PropTypes.number.isRequired,
    tripDetails: PropTypes.arrayOf(tripDetailsShape).isRequired,
    tripId: PropTypes.string.isRequired,
    tripLegs: PropTypes.shape({
        all: PropTypes.arrayOf(PropTypes.object).isRequired,
        filtered: PropTypes.arrayOf(PropTypes.object).isRequired,
    }),
    tripModes: PropTypes.arrayOf(PropTypes.string).isRequired,
    tripPricing: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const tripShape = PropTypes.shape(tripSchema);

export {
    accessibilityShape,
    departArriveShape,
    promotionShape,
    tripDetailsShape,
    tripSchema,
    tripShape,
};
